/**
 * The app's root url -- which is also the landing page after login
 */
export const ROOT = process.env.PUBLIC_URL || '';
export const ROOT_PATH = `${ROOT}/`;

/**
 * A page on which components can be built and tested free of interference
 */
export const TEST_GROUND_ROUTE = ROOT + '/testing';

/**
 * The guest search results path. If we're doing a search, this is where we show it.
 */
export const GUEST = 'guest';
export const GUEST_SEARCH_ROUTE = `${ROOT}/${GUEST}`;

/***
 * The path to the Resort Entitlement Mapping page
 */
export const PRODUCT_MAPPING = 'product_mapping';
export const PRODUCT_MAPPING_ROUTE = `${ROOT}/${PRODUCT_MAPPING}`;

/***
 * The path to the Resort Validation Configuration page
 */
export const VALIDATION_CONFIGURATION = 'validation_configuration';
export const VALIDATION_CONFIGURATION_ROUTE = `${ROOT}/${VALIDATION_CONFIGURATION}`;

/**
 * The root path for the admin routes -- these are the routes that let an admin do their various administrative actions
 * like CRUDing users.
 */
export const ADMIN = 'admin';
export const ADMIN_ROOT = `${ROOT}/${ADMIN}`;

/**
 * The path for admins to CRUD users
 */
export const MANAGE_USERS = 'manage_users';
export const USER_MANAGEMENT_ROUTE = `${ADMIN_ROOT}/${MANAGE_USERS}`;

/**
 * The path to manage resort settings
 */
export const SYSTEM_ADMIN = 'system_admin';
export const SYSTEM_ADMIN_ROUTE = `${ADMIN_ROOT}/${SYSTEM_ADMIN}`;

/**
 * The path to the FAQ
 */
export const FAQ = 'faq';
export const FAQ_ROUTE = `${ROOT}/${FAQ}`;

/**
 * The path to the Release Notes
 */
export const RELEASE_NOTES = 'release_notes';
export const RELEASE_NOTES_ROUTE = `${ROOT}/${RELEASE_NOTES}`;

/**
 * The path to the Help and Training section
 */
export const HELP_AND_TRAINING = 'help_and_training';
export const HELP_AND_TRAINING_ROUTE = `${ROOT}/${HELP_AND_TRAINING}`;


/**
 * The app's login page.
 */
export const LOGIN_ROUTE = ROOT + '/login';

/**
 * Path to the reporting page.
 */
export const REPORTS = 'reports';
export const REPORTS_ROUTE = `${ROOT}/${REPORTS}`;

/**
 * Path to the Product Administration page.
 */
export const PRODUCT_ADMINISTRATION = 'product_administration';
export const PRODUCT_ADMINISTRATION_ROUTE = `${ROOT}/${PRODUCT_ADMINISTRATION}`;

export const PRODUCT = 'product';
export const PRODUCT_ROUTE = `${PRODUCT_ADMINISTRATION_ROUTE}/${PRODUCT}`;

export const ACCESS = 'access';
export const ACCESS_ROUTE = `${PRODUCT_ADMINISTRATION_ROUTE}/${ACCESS}`;

export const ACCESS_OVERVIEW = 'access_overview';
export const ACCESS_OVERVIEW_ROUTE = `${PRODUCT_ADMINISTRATION_ROUTE}/${ACCESS_OVERVIEW}`;

export const GLOBAL = 'global';
export const GLOBAL_ROUTE = `${PRODUCT_ADMINISTRATION_ROUTE}/${GLOBAL}`;